// Mock DeepAR implementation for development
// Use this when the real DeepAR fails to load due to CORS/WASM issues

export const createMockDeepAR = () => {
  const mockCanvas = {
    width: 1280,
    height: 720
  };

  const mockCallbacks = {
    onFaceVisibilityChanged: null
  };

  return {
    initialize: async (config) => {
      console.log('🎭 Mock DeepAR initialized with config:', config);
      
      // Simulate initialization delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Mock successful initialization
      return {
        callbacks: mockCallbacks,
        canvas: mockCanvas,
        setVideoElement: (video, autoplay = true) => {
          console.log('🎭 Mock DeepAR: Video element set', { video, autoplay });
        },
        switchEffect: async (effectPath) => {
          console.log('🎭 Mock DeepAR: Effect switched to:', effectPath);
          await new Promise(resolve => setTimeout(resolve, 500));
        },
        clearEffect: () => {
          console.log('🎭 Mock DeepAR: Effect cleared');
        },
        shutdown: () => {
          console.log('🎭 Mock DeepAR: Shutdown');
        }
      };
    }
  };
};

export const loadMockDeepAR = () => {
  console.log('🎭 Loading Mock DeepAR for development');
  return Promise.resolve(createMockDeepAR());
};